import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

@Component({
    selector: 'isophi-app-portfolio-plan-description',
    templateUrl: './portfolio-plan-description.component.html',
    styleUrls: ['./portfolio-plan-description.component.scss'],
    standalone: false
})
export class PortfolioPlanDescriptionComponent implements OnInit {
  @Input()
  control!: FormControl;

  @Input()
  title = '';

  @Input()
  allowEditMode = true;

  @Output()
  requestSave$ = new EventEmitter<string>();

  initValue = '';

  ngOnInit(): void {
    this.initValue = this.control.value;
    this.control.setValidators([Validators.required]);
  }

  cancel(): void {
    this.control.setValue(this.initValue);
  }

  save(): void {
    this.initValue = this.control.value;
    this.requestSave$.emit(this.control.value);
  }
}
